import { render, staticRenderFns } from "./InitiaSelf.vue?vue&type=template&id=dc849e1e&scoped=true"
import script from "./InitiaSelf.vue?vue&type=script&lang=js"
export * from "./InitiaSelf.vue?vue&type=script&lang=js"
import style0 from "./InitiaSelf.vue?vue&type=style&index=0&id=dc849e1e&prod&lang=less&scoped=true"
import style1 from "./InitiaSelf.vue?vue&type=style&index=1&id=dc849e1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc849e1e",
  null
  
)

export default component.exports